import { Box, Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { DocumentValidityStatus } from "web_myplann/Profile/Helpers/paperworkDocument";
import { getPaperworkValidityColors } from "web_myplann/Profile/Helpers/paperworkValidityColors";

type Props = {
	status: DocumentValidityStatus;
	formatted?: string;
};

const R = Resources.Paperwork;

export const PaperworkValidityBanner: FC<Props> = ({ status, formatted }) => {
	const { palette } = useTheme();
	const { t } = useResource();

	const colors = getPaperworkValidityColors(palette, status);

	return (
		<Box px={1.6}>
			<Stack
				direction="row"
				alignItems="center"
				justifyContent="space-between"
				gap={2}
				px={1.6}
				py={1.2}
				bgcolor={colors.bg}
				border={1}
				borderColor={colors.border}
				borderRadius={"12px"}
			>
				<Typography variant="bodyStrong" color={colors.text}>
					{t(R.Detail.Status[status])}
				</Typography>
				{formatted && (
					<Typography variant="body2" color={colors.text} tabular>
						{t(R.Validity.until, { date: formatted })}
					</Typography>
				)}
			</Stack>
		</Box>
	);
};
